import axios from "axios";
// import { Header } from "rsuite";

export const patchKycOcrApi = async (data) => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/aadhaar`, data, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
        
        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.message) {
            return { message: error.response.message };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};




export const patchKycPanOcrApi = async (data) => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/pan`, data, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.message) {
            return { message: error.response.message };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};


export const getKycPanOcrApi = async () => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/pan`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });

        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.message) {
            return { message: error.response.message };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};

export const patchKycDLOcrApi = async (data) => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/dl`, data, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
       
        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.message) {
            return { message: error.response.message };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};


export const postKycOcrApi = async (data) => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/verify`, data, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
       
        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.data) {
            return { message: error.response.data };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};


export const getKycOcrApi = async () => {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
    const apiKey = process.env.REACT_APP_API_KEY;

    const setAuthHeader = (token) => {
        return token ? `Bearer ${token}` : null;
    };
    try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/digilocker/get-verified-data`, {
            headers: {
                Authorization: setAuthHeader(token),
                "Content-Type": "application/json",
                "x-api-key": apiKey,
                // "ngrok-skip-browser-warning": "69420"
            }
        });
    
        return response.data;
    } catch (error) {
        console.log("API ERRoR", error);
        if (error.response.message) {
            return { message: error.response.message };
        } else if (error.request) {
            return { message: 'server not found' };
        } else {
            return { message: error.message };
        }
    };
};